import Vue from 'vue';
import './registerServiceWorker';
import router from './router';

import { VueDiContainer } from 'vue-di-container';

// Plugins
import i18n from '@/plugins/i18n';
import ValidatorPlugin from '@moj/najiz-validators';
import vuetify from '@/plugins/vuetify';
import initializeApplication from '@/plugins/application-initialization';
import najizMui from '@moj/najiz-mui';
import najizToaster, { IToasterAPI } from '@moj/najiz-toastify';
import { TrackerElement } from '@moj/najiz-tracking';

// Components
import App from './App/app';
import PersonaContainer from './modules/shared/components/persona/persona-container/persona-container';
import GovernmentalPersona from './modules/shared/components/persona/governmental-persona/governmental-persona';
import LawyerPersona from './modules/shared/components/persona/lawyer-persona/lawyer-persona';
import IndividualPersona from './modules/shared/components/persona/individual-persona/individual-persona';
import AnonymousPersona from './modules/shared/components/persona/anonymous-persona/anonymous-persona';
import BusinessPersona from './modules/shared/components/persona/business-persona/business-persona';
import BasePersona from './modules/shared/components/persona/base-persona/base-persona';

import HttpService from './modules/shared/services/httpService';
import UserService from './modules/shared/services/userService';
import SharedDataService from './modules/shared/services/shared-data-service';

// styles
import './assets/styles/main.scss';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.use(VueDiContainer);
Vue.use(najizMui);
Vue.use(ValidatorPlugin, { i18n });
Vue.use(najizToaster);

Vue.component('BasePersona', BasePersona);
Vue.component('PersonaContainer', PersonaContainer);
Vue.component('AnonymousPersona', AnonymousPersona);
Vue.component('IndividualPersona', IndividualPersona);
Vue.component('BusinessPersona', BusinessPersona);
Vue.component('GovernmentalPersona', GovernmentalPersona);
Vue.component('LawyerPersona', LawyerPersona);
Vue.component('TrackerElement', TrackerElement);

declare module 'vue/types/vue' {
  interface Vue {
    $appInsights: any;
    $nToaster: IToasterAPI;
    trackingController:any;
  }
}

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';

initializeApplication().then(() => {
  // const userService = new UserService();
  // userService.httpService = new HttpService();

  // Vue.use(trackingController, {
  //   router,
  //   http,
  //   appInfo: window.$config.ApplicationInsights,
  //   userService,
  // });

  new Vue({
    i18n,
    router,
    vuetify,
    diProvide: [
      HttpService,
      UserService,
      SharedDataService,
    ],
    render: (h) => h(App),
  }).$mount('#app');
});
